import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, ShadowTypeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { View } from 'react-native';
import Button from '../button/Button';
import Card from '../card/Card';
import Space from '../space/Space';
import Typography from '../typography/Typography';
const CtaCard = ({ label, info, actionLabel, action, triggerAction, onPress, isLoading, buttonType = ButtonTypeTokens.LargeFilled, labelColor = ColorTokens.White, }) => {
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { bgColor: ColorTokens.White, borderRadius: BorderRadiusTokens.BR0, shadow: ShadowTypeTokens.E6, body: {
                children: [
                    React.createElement(View, { style: {
                            flexDirection: 'column',
                            flex: 1,
                        } },
                        label ? (React.createElement(React.Fragment, null,
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    alignItems: 'flex-start',
                                    flex: 1,
                                } },
                                React.createElement(View, { style: {
                                        flex: 1,
                                        justifyContent: 'center',
                                    } },
                                    React.createElement(Typography, { label: label, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night })),
                                React.createElement(View, { style: {
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                        flex: 1,
                                    } }, info ? (React.createElement(React.Fragment, null,
                                    React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night }),
                                    React.createElement(Typography, { label: info, fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night }),
                                    React.createElement(Space, { size: SizeTypeTokens.XL }))) : (React.createElement(React.Fragment, null)))),
                            React.createElement(Space, { size: SizeTypeTokens.XL }))) : (React.createElement(React.Fragment, null)),
                        React.createElement(Button, { type: buttonType, width: ButtonWidthTypeToken.FULL, label: actionLabel, fontFamily: FontFamilyTokens.Poppins, labelColor: labelColor, onPress: handleAction, loading: isLoading })),
                ],
            } })));
};
export default memo(CtaCard);
export { CtaCard };
